import { twMerge } from 'tailwind-merge'
import { clsx, ClassArray } from 'clsx'

const cn = (...args: ClassArray) => twMerge(clsx(args))

export default cn
